import React from 'react'
import { Card, DatePicker, Select } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'
import { generateTimeSlots } from '../utils'

const DateTimeSelection = ({ bookingDate, setBookingDate, bookingStart, setBookingStart, event, token }) => {
  return (
    <Card
      title={
        <>
          <ClockCircleOutlined style={{ color: token.colorPrimary }} /> Date & Time
        </>
      }
      bordered={false}
      size='small'
      style={{ boxShadow: '0 1px 2px rgba(0,0,0,0.05)', height: '100%' }}
      headStyle={{ padding: '6px 10px', fontSize: '13px' }}
      bodyStyle={{ padding: '8px 10px' }}
    >
      <DatePicker
        disabled={event?.extendedProps?.availabilityRecordId}
        format='DD MMMM YYYY'
        allowClear={false}
        value={bookingDate}
        onChange={(date) => setBookingDate(date)}
        style={{ width: '100%', marginBottom: 8 }}
        size='middle'
      />
      <Select
        disabled={event?.extendedProps?.availabilityRecordId}
        value={bookingStart}
        onChange={(time) => setBookingStart(time)}
        placeholder='- Select time -'
        suffixIcon={<ClockCircleOutlined style={{ color: token.colorPrimary }} />}
        showSearch
        size='middle'
        style={{ width: '100%' }}
        options={generateTimeSlots().map((option) => ({ label: option, value: option }))}
      />
    </Card>
  )
}

export default DateTimeSelection
